"use client";

import { useEffect } from "react";

/** Syncs `<html lang>` and CJK font class with the active App Router locale. */
export function HtmlLang({ locale }: { locale: string }) {
  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.classList.toggle(
      "font-cjk-sc",
      locale === "zh-CN"
    );
    document.documentElement.classList.toggle(
      "font-cjk-tc",
      locale === "zh-HK"
    );
  }, [locale]);

  return null;
}
